interface IQueueItem {
    $command?: string;
    onready?: (data?: any) => void;
}

interface ITrackingEvent extends IQueueItem {
    type?: string;
    event: string;
    payload?: object;
}

class SmasiEngineChannel {
    private initQueue: Array<ITrackingEvent> = new Array<ITrackingEvent>();
    public scopeName: string = 'SmasiEngineChannel';

    constructor(initQueue?: Array<ITrackingEvent>) {
        if (initQueue) {
            if (Array.isArray(initQueue) && initQueue.length > 0)
                this.initQueue.push.apply(this.initQueue, initQueue);
        }

        this.push.apply(this, this.initQueue);
        this.initQueue.length = 0;
    }

    public push(...items: ITrackingEvent[]): number {

        if (items.length === 0)
            return 0;

        items = JSON.parse(JSON.stringify(items));

        window.parent.postMessage({
            func: 'push',
            data: items,
            source: 'SmasiEngineChannel'
        }, "*");

        return items.length;
    }
}

export function isSmasiEngineChannel(channel: any) {
    return channel instanceof SmasiEngineChannel || (channel && (<SmasiEngineChannel>channel).scopeName == 'SmasiEngineChannel');
};

let current: any = (<any>window).smartSignals2;
let smartSignals2 = (<any>window).smartSignals2 = isSmasiEngineChannel(current) ? current : new SmasiEngineChannel(current);

export default smartSignals2;
